import React from "react";
import { InformationalBannerDismissalStyle } from "../../../../../../common/service/server/dto/CMPSettingsDto";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";
import { ConsentOptionCards } from "../../../consentBanner/ConsentOptionCards";

const DismissalPreview = ({ src }: { src: string }) => (
  <img
    src={src}
    alt=""
    className="block w-full rounded-[6px] border border-solid border-neutral-200 bg-white"
  />
);

export const ConsentBannerUSDismissalRow = () => {
  return (
    <ConsentSettingRow
      title="Dismiss options"
      helpText="How visitors close the informational banner."
    >
      <ConsentOptionCards
        field="informationalBannerDismissalStyle"
        ariaLabel="Informational banner dismiss options"
        options={[
          {
            value: InformationalBannerDismissalStyle.ACCEPT_BUTTON,
            label: "Accept button",
            note: "Default",
            preview: (
              <DismissalPreview src="/assets/images/stay_compliant/privacy_center/consent/info_dismissal_accept.svg" />
            ),
          },
          {
            value: InformationalBannerDismissalStyle.ACCEPT_AND_X_BUTTON,
            label: "Accept and X button",
            preview: (
              <DismissalPreview src="/assets/images/stay_compliant/privacy_center/consent/info_dismissal_accept_and_x.svg" />
            ),
          },
        ]}
      />
    </ConsentSettingRow>
  );
};
